<ul class="tabbable-nav">
  <li
    *ngFor="let navigationLink of tabs"
    [ngClass]="{ active: navigationLink.isActive }"
    [abAccess]="navigationLink.fields.Link?.url"
    [checkAccess]="isTransfer(navigationLink.fields.Link)"
  >
    <ng-container
      *ngIf="navigationLink.fields.Link && !navigationLink.isActive"
    >
      <a [routerLink]="navigationLink.fields.Link.url"
        ><span
          *scText="navigationLink.fields.label || navigationLink.fields.Title"
        ></span
      ></a>
    </ng-container>
    <ng-container
      *ngIf="!navigationLink.fields.Link || navigationLink.isActive"
    >
      <span
        *scText="navigationLink.fields.label || navigationLink.fields.Title"
        (click)="selectActiveTab(navigationLink)"
      ></span>
    </ng-container>
  </li>
</ul>
